module.exports = __webpack_public_path__ + "videos/3.2d32f7a.mp4";